document.addEventListener('DOMContentLoaded', function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  /* ---------- Gallery synced to color ---------- */
  var items = $$('.cgr-gallery-item'), thumbs = $$('.cgr-gallery-thumb');
  function showItem(set, idx) {
    items.forEach(function (i) { i.classList.toggle('active', i.dataset.colorSet === set && i.dataset.index === String(idx)); });
    thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.colorSet === set && t.dataset.index === String(idx)); });
    items.forEach(function (i) { var v = $('video', i); if (v) { if (i.classList.contains('active')) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } } });
  }
  function syncGallery(color) {
    var set = /pink/i.test(color) ? 'pink' : 'purple';
    thumbs.forEach(function (t) { t.style.display = t.dataset.colorSet === set ? '' : 'none'; });
    showItem(set, 1);
    var dot = $('#cgr-sticky-swatch');
    if (dot) { dot.classList.toggle('pink', set === 'pink'); dot.classList.toggle('purple', set === 'purple'); }
    window.cgrCurrentSet = set;
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showItem(t.dataset.colorSet, t.dataset.index); }); });
  if (items.length) syncGallery('Millennial Pink');

  /* ---------- Bundles & swatches ---------- */
  var cards = $$('.cgr-bundle-card'), variantInput = $('#cgr-selected-variant-id'), stickyPrice = $('#cgr-sticky-price');
  function selectCard(card) {
    cards.forEach(function (c) { c.classList.remove('selected'); c.setAttribute('aria-checked', 'false'); });
    card.classList.add('selected'); card.setAttribute('aria-checked', 'true');
    if (variantInput) variantInput.value = card.dataset.variantId || '';
    if (stickyPrice) stickyPrice.textContent = card.dataset.bundlePrice;
    var c1 = $('.cgr-curler-color-row[data-curler="1"] .cgr-swatch-btn.selected', card);
    if (c1) syncGallery(c1.dataset.color);
  }
  cards.forEach(function (card) {
    card.addEventListener('click', function (e) { if (e.target.closest('.cgr-swatch-btn') || e.target.closest('.cgr-shortcut-btn')) return; selectCard(card); });
    card.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === card) { e.preventDefault(); selectCard(card); } });
  });
  function pick(row, color) {
    $$('.cgr-swatch-btn', row).forEach(function (b) { var on = b.dataset.color === color; b.classList.toggle('selected', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
  }
  $$('.cgr-swatch-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = btn.closest('.cgr-bundle-card'); if (!card.classList.contains('selected')) selectCard(card);
      var row = btn.closest('.cgr-curler-color-row'); pick(row, btn.dataset.color);
      if (row.dataset.curler === '1') syncGallery(btn.dataset.color);
    });
  });
  $$('.cgr-shortcut-btn').forEach(function (sc) {
    sc.addEventListener('click', function (e) {
      e.stopPropagation();
      $$('.cgr-curler-color-row', sc.closest('.cgr-bundle-card')).forEach(function (row, i) { pick(row, i % 2 === 0 ? 'Millennial Pink' : 'Lavender Purple'); });
      syncGallery('Millennial Pink');
    });
  });
  $$('.cgr-select-colorway').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = $('.cgr-bundle-card.selected');
      if (card) { $$('.cgr-curler-color-row', card).forEach(function (row) { pick(row, btn.dataset.color); }); }
      syncGallery(btn.dataset.color);
      var bb = $('#cgr-buy-box'); if (bb) bb.scrollIntoView({ behavior: 'smooth' });
    });
  });

  /* ---------- Cart ---------- */
  var drawer = $('#cgr-cart-drawer'), backdrop = $('#cgr-cart-backdrop'), body = $('#cgr-drawer-items'), sub = $('#cgr-drawer-subtotal');
  function openCart() { drawer.classList.add('active'); backdrop.classList.add('active'); drawer.setAttribute('aria-hidden', 'false'); }
  function closeCart() { drawer.classList.remove('active'); backdrop.classList.remove('active'); drawer.setAttribute('aria-hidden', 'true'); }
  $('#cgr-close-cart-btn').addEventListener('click', closeCart); backdrop.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  function renderCart(cart) {
    if (!cart.items.length) { body.innerHTML = '<p>Your cart is empty.</p>'; sub.textContent = '$0.00'; return; }
    body.innerHTML = '';
    cart.items.forEach(function (it, i) {
      var props = '';
      Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k]) props += '<div class="cgr-cart-prop"></div>'; });
      var div = document.createElement('div'); div.className = 'cgr-drawer-line';
      var left = document.createElement('div');
      var t = document.createElement('strong'); t.textContent = it.product_title; left.appendChild(t);
      var v = document.createElement('div'); v.textContent = it.variant_title || ''; left.appendChild(v);
      Object.keys(it.properties || {}).forEach(function (k) { if (it.properties[k]) { var p = document.createElement('div'); p.className = 'cgr-cart-prop'; p.textContent = k + ': ' + it.properties[k]; left.appendChild(p); } });
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'cgr-drawer-remove'; rm.textContent = 'Remove';
      rm.addEventListener('click', function () { fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: i + 1, quantity: 0 }) }).then(function (r) { return r.json(); }).then(renderCart); });
      left.appendChild(rm);
      var price = document.createElement('div'); price.textContent = money(it.final_line_price);
      div.appendChild(left); div.appendChild(price); body.appendChild(div);
    });
    sub.textContent = money(cart.total_price);
  }
  function refreshCart() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart); }

  function showMsg(t) { var m = $('#cgr-form-msg'); if (m) { m.hidden = !t; m.textContent = t || ''; } }
  function cardIds() { return cards.map(function (c) { return parseInt(c.dataset.variantId, 10) || 0; }); }
  /* If the theme could not find variants, look them up from the store itself */
  function resolveVariants() {
    if (cardIds().every(Boolean)) return Promise.resolve();
    return fetch('/products.json?limit=250').then(function (r) { return r.json(); }).then(function (d) {
      var list = d.products || [];
      var prod = list.filter(function (p) { return /tulip|curler|cozyglow/i.test(p.title); })[0] || list[0];
      if (!prod || !prod.variants.length) return;
      var vs = prod.variants, by = { Single: null, Duo: null, Trio: null };
      vs.forEach(function (v) { var t = (v.title || '').toLowerCase(); if (/single/.test(t)) by.Single = v.id; else if (/duo/.test(t)) by.Duo = v.id; else if (/trio/.test(t)) by.Trio = v.id; });
      by.Single = by.Single || vs[0].id; by.Duo = by.Duo || (vs[1] ? vs[1].id : by.Single); by.Trio = by.Trio || (vs[2] ? vs[2].id : by.Duo);
      cards.forEach(function (c) { if (!parseInt(c.dataset.variantId, 10)) c.dataset.variantId = by[c.dataset.bundleTier]; });
    }).catch(function () {});
  }
  function fallbackSubmit(id, qty, props, mode) {
    var f = document.createElement('form'); f.method = 'post'; f.action = '/cart/add'; f.style.display = 'none';
    function add(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
    add('id', id); add('quantity', qty);
    Object.keys(props).forEach(function (k) { add('properties[' + k + ']', props[k]); });
    add('return_to', mode === 'checkout' ? '/checkout' : '/cart');
    document.body.appendChild(f); f.submit();
  }
  var adding = false;
  function addBundle() {
    var card = $('.cgr-bundle-card.selected'), btn = $('.cgr-cta-submit');
    if (!card || adding) return;
    adding = true; showMsg('');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    var done = function () { adding = false; if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Claim My Ritual Offer →'; } };
    var mode = (form && form.dataset.afterAdd) || 'checkout';
    resolveVariants().then(function () {
      var id = parseInt(card.dataset.variantId, 10);
      if (!id) { showMsg('Sorry, this offer is temporarily unavailable. Please refresh the page and try again.'); done(); return; }
      var ids = cardIds(), same = ids.every(function (x) { return x === ids[0]; });
      var qty = same ? (parseInt(card.dataset.qty, 10) || 1) : 1;
      var props = { 'Bundle': card.dataset.bundleTier };
      $$('.cgr-curler-color-row', card).forEach(function (row) { var s = $('.cgr-swatch-btn.selected', row); props['Curler ' + row.dataset.curler + ' color'] = s ? s.dataset.color : ''; });
      var start = mode === 'checkout' ? fetch('/cart/clear.js', { method: 'POST' }).catch(function () {}) : Promise.resolve();
      return start.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty, properties: props }] }) });
      }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { if (mode === 'checkout') { window.location.href = '/checkout'; } else { return refreshCart().then(function () { openCart(); done(); }); } })
        .catch(function () { fallbackSubmit(id, qty, props, mode); });
    }).catch(function () { showMsg('Something went wrong. Please try again.'); done(); });
  }
  var form = $('#cgr-hero-atc-form');
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addBundle(); });
  var stickyBtn = $('#cgr-sticky-atc-btn'); if (stickyBtn) stickyBtn.addEventListener('click', addBundle);
  refreshCart();

  /* ---------- FAQ ---------- */
  $$('.cgr-faq-item').forEach(function (item) {
    var q = $('.cgr-faq-question', item);
    q.addEventListener('click', function () {
      var on = item.classList.toggle('active'); q.setAttribute('aria-expanded', on ? 'true' : 'false'); $('.cgr-faq-icon', item).textContent = on ? '−' : '+';
    });
  });

  /* ---------- Videos ---------- */
  var vids = $$('.cgr-video-card video, .cgr-buybox-demo video');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
  $$('.cgr-video-card').forEach(function (card) {
    var v = $('video', card), pb = $('.cgr-vid-play', card), mb = $('.cgr-vid-mute', card);
    pb.addEventListener('click', function () { if (v.paused) { v.play(); pb.textContent = '❚❚'; } else { v.pause(); pb.textContent = '▶'; } });
    mb.addEventListener('click', function () { v.muted = !v.muted; mb.textContent = v.muted ? '🔇' : '🔊'; });
    v.addEventListener('pause', function () { pb.textContent = '▶'; }); v.addEventListener('play', function () { pb.textContent = '❚❚'; });
  });

  /* ---------- Sticky buy bar ---------- */
  var hero = $('#cgr-buy-box'), bar = $('#cgr-sticky-buy-bar');
  if (hero && bar) window.addEventListener('scroll', function () { bar.classList.toggle('visible', hero.getBoundingClientRect().bottom < 0); }, { passive: true });
});
